import { useState } from "react";
import PagePadding from "../layouts/PagePadding";
import Input from "../components/form-input/Input";
import Btn from "../components/btn/create-account/Btn";
import Outer from "../layouts/form/Outer";
import Inner from "../layouts/form/Inner";
import Footer from "../components/onboarding/Footer";
import { handleDisable } from "../utils/btn/handleDisable";
import { useNavigate, Link } from "react-router-dom";
import req from "../axios/interceptedAxiosInstance";
import CreateNewPassword from "./CreateNewPassword";
import IsLoading from "../components/loading/IsLoading";
import { successToast } from "../notification/notification";

export const ForgotPassword = ({ setLoading }) => {
  const [email, setEmail] = useState("");

  const [formIsSubmitted, setFormIsSubmitted] = useState(false);

  const navigate = useNavigate();

  const resetPwdBody = { email: email };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await req.post("auth/reset-password", resetPwdBody);
      successToast(response?.data?.message);
      setLoading(false);
      setFormIsSubmitted(true);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  let disable = handleDisable([email]);

  if (formIsSubmitted) return <CreateNewPassword email={email} />;

  return (
    <div className="relative">
      <PagePadding>
        <Outer>
          <Inner>
            <div className="mt-4 flex w-fit gap-14 items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-chevron-left cursor-pointer"
                viewBox="0 0 16 16"
                onClick={() => navigate(-1)}
              >
                <path
                  fillRule="evenodd"
                  d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                />
              </svg>
              <h4 className="font-normal text-2xl">Reset Password</h4>
            </div>

            <form className="mt-8">
              <Input
                type="email"
                placeholder="Email Address"
                required={true}
                value={email}
                onValueChange={setEmail}
              />
              <div>
                <Btn
                  innerText="Reset Password"
                  inactive="bg-darkGrey"
                  active="bg-logoRed"
                  onclick={handleSubmit}
                  disable={disable}
                />
              </div>
            </form>
            <Link to="/sign-in">
              <div>
                <Btn
                  innerText="Back to login"
                  active="bg-black"
                  disable={false}
                />
              </div>
            </Link>
          </Inner>
        </Outer>
      </PagePadding>
      <Footer />
    </div>
  );
};

export default IsLoading(ForgotPassword, "Sending OTP");
